import { Toaster } from 'sonner';
import { CHAT_INCOMING_TOASTER_ID } from '../model/config';

/** Размещает новые сообщения в развёрнутой стопке без перекрытия карточек */
export const ChatIncomingToaster = () => (
    <Toaster
        id={CHAT_INCOMING_TOASTER_ID}
        position="bottom-left"
        expand
        visibleToasts={5}
        gap={12}
        containerAriaLabel="Новые сообщения"
    />
);
